import { customElement } from "lit/decorators.js";
import { Chart, type ChartDefinition } from "../Chart";

@customElement("s-pewma-latency-chart")
export class PewmaLatencyChart extends Chart {
	protected override readonly definition: ChartDefinition = {
		title: "50, 95, 99 percentile latencies",
		summary:
			"PEWMA has lower latency than least connections at all three percentiles, with the largest improvement at the 95th and 99th percentiles.",
		xMinimum: 0,
		xMaximum: 59,
		xTickStep: 4,
		yMinimum: 0,
		yMaximum: 3000,
		xAxisTitle: "Time elapsed (seconds)",
		yAxisTitle: "Response time (ms)",
		series: [
			{
				name: "Least Connections (LC) 50%ile",
				points: [
					{ x: 0, y: 949.962 },
					{ x: 2, y: 808.301 },
					{ x: 3, y: 799.968 },
					{ x: 4, y: 858.299 },
					{ x: 6, y: 866.632 },
					{ x: 8, y: 841.633 },
					{ x: 12, y: 841.633 },
					{ x: 27, y: 891.631 },
					{ x: 59, y: 898.145 },
				],
				color: "var(--chart-green)",
				texture: "dotted",
				legendLabel: "Least Connections",
			},
			{
				name: "Least Connections (LC) 95%ile",
				points: [
					{ x: 0, y: 949.962 },
					{ x: 3, y: 1904.924 },
					{ x: 4, y: 1829.927 },
					{ x: 5, y: 1907.734 },
					{ x: 8, y: 1646.619 },
					{ x: 11, y: 1635.804 },
					{ x: 14, y: 1568.961 },
					{ x: 17, y: 1631.578 },
					{ x: 19, y: 1610.03 },
					{ x: 21, y: 1642.851 },
					{ x: 30, y: 1605.631 },
					{ x: 54, y: 1630.768 },
					{ x: 59, y: 1616.602 },
				],
				color: "var(--chart-green)",
				texture: "dotted",
				showInLegend: false,
			},
			{
				name: "Least Connections (LC) 99%ile",
				points: [
					{ x: 0, y: 949.962 },
					{ x: 1, y: 1488.107 },
					{ x: 2, y: 1631.268 },
					{ x: 3, y: 2026.919 },
					{ x: 16, y: 1940.492 },
					{ x: 17, y: 2022.919 },
					{ x: 19, y: 2007.92 },
					{ x: 21, y: 2057.084 },
					{ x: 40, y: 2040.668 },
					{ x: 51, y: 1969.171 },
					{ x: 52, y: 2042.418 },
					{ x: 59, y: 2046.501 },
				],
				color: "var(--chart-green)",
				texture: "dotted",
				showInLegend: false,
			},
			{
				name: "PEWMA 50%ile",
				points: [
					{ x: 0, y: 708 },
					{ x: 1, y: 708.305 },
					{ x: 2, y: 783.302 },
					{ x: 4, y: 766.636 },
					{ x: 8, y: 816.634 },
					{ x: 11, y: 799.968 },
					{ x: 12, y: 824.967 },
					{ x: 16, y: 837.466 },
					{ x: 18, y: 824.967 },
					{ x: 23, y: 849.966 },
					{ x: 30, y: 824.967 },
					{ x: 38, y: 858.299 },
					{ x: 59, y: 858.299 },
				],
				color: "var(--chart-red)",
				texture: "dash-dot",
				legendLabel: "PEWMA",
			},
			{
				name: "PEWMA 95%ile",
				points: [
					{ x: 0, y: 1621 },
					{ x: 1, y: 1621.602 },
					{ x: 2, y: 1452.025 },
					{ x: 3, y: 1616.185 },
					{ x: 5, y: 1342.03 },
					{ x: 6, y: 1271.616 },
					{ x: 8, y: 1283.282 },
					{ x: 9, y: 1375.362 },
					{ x: 11, y: 1282.449 },
					{ x: 12, y: 1279.115 },
					{ x: 13, y: 1347.029 },
					{ x: 16, y: 1293.698 },
					{ x: 25, y: 1323.28 },
					{ x: 30, y: 1291.615 },
					{ x: 59, y: 1291.615 },
				],
				color: "var(--chart-red)",
				texture: "dash-dot",
				showInLegend: false,
			},
			{
				name: "PEWMA 99%ile",
				points: [
					{ x: 0, y: 1890 },
					{ x: 1, y: 1890.924 },
					{ x: 2, y: 1857.009 },
					{ x: 3, y: 1893.091 },
					{ x: 7, y: 1813.761 },
					{ x: 8, y: 1823.26 },
					{ x: 13, y: 1740.014 },
					{ x: 17, y: 1716.931 },
					{ x: 18, y: 1739.004 },
					{ x: 26, y: 1733.623 },
					{ x: 55, y: 1682.433 },
					{ x: 59, y: 1704.598 },
				],
				color: "var(--chart-red)",
				texture: "dash-dot",
				showInLegend: false,
			},
		],
	};
}
